import { isEqual, omit } from 'lodash';

import { getLogCriteria, getLogCriteriaContainers } from '../../declarations/log-filters/log-filters';
import { FilterPartialExpression } from '../../typings/filter';
import { LogParams, LogSourceParams } from '../../typings/log';
import {
    flattenContainer,
    getValidExpressions,
    parseFilterFromString,
    serializeFilterToString
} from '../FilterHelpers/FilterHelpers';
import { LogHelpers } from '../LogHelpers/LogHelpers';

export class LogSourceHelper {
    static normalizeParams<E>(param: string | null, values: { default: E }): E {
        if (param !== null && values[param]) {
            return values[param];
        }

        return values.default;
    }

    static getFilter(filter: string, logParams?: LogParams): FilterPartialExpression[] {
        const criteria = getLogCriteria();
        const filterExpressions = parseFilterFromString(criteria, filter, true);
        const logExpression = LogHelpers.parseLogParams(criteria, logParams);

        // убираем из списка дополнительных фильтров те
        // которые уже есть в инлайновом фильтре
        // так как он приоритетнее
        const filteredExpressions = logExpression.filter(paramFilter => {
            return !filterExpressions.find(inlineFilter => {
                return inlineFilter.field === paramFilter.field;
            });
        });

        return filteredExpressions.concat(filterExpressions);
    }

    static isParamsMeaningfullyDifferent(
        newParams: LogSourceParams | undefined,
        oldParams: LogSourceParams | undefined
    ): boolean {
        if (newParams === oldParams) {
            return false;
        }

        if (newParams !== undefined && oldParams !== undefined) {
            if (newParams.filter !== oldParams.filter) {
                return (
                    LogSourceHelper.isLogFilterDifferent(oldParams.filter, newParams.filter) ||
                    !isEqual(omit(newParams, ['filter']), omit(oldParams, ['filter']))
                );
            } else {
                return !isEqual(newParams, oldParams);
            }
        }

        return true;
    }

    private static isLogFilterDifferent(
        oldFilter?: FilterPartialExpression[],
        newFilter?: FilterPartialExpression[]
    ): boolean {
        const filterCriteriaContainers = getLogCriteriaContainers();

        const filterCriteria = flattenContainer(filterCriteriaContainers);

        const newExpressions = getValidExpressions(filterCriteria, newFilter || []);
        const oldExpressions = getValidExpressions(filterCriteria, oldFilter || []);

        return serializeFilterToString(newExpressions) !== serializeFilterToString(oldExpressions);
    }
}
